// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main-title[data-v-8f99dc3e] {\r\n  color: #979696;\n}\n.numbers[data-v-8f99dc3e] {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  width: 100%;\r\n  font-weight: bold;\r\n  font-size: 1rem;\n}\n.rating-field[data-v-8f99dc3e] {\r\n  display: none;\n}\n@media (max-width: 590px) {\n.rating[data-v-8f99dc3e] {\r\n    display: none;\n}\n.rating-field[data-v-8f99dc3e] {\r\n    display: block;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
